import { atomWithKey as atom } from "./atomWithKey";
import {
  LocationPermissionState,
  LocationState,
} from "../Types/Types/FmlmSearch/FmlmSearchType";
import { DEFAULT_FMLM_FILTER_STATE, IFmlmFilter, IFmlmJourneyResponseAtom, IFmlmView } from "../Types/Interface/IFmlmView";
import { ReverseGeocodeResult } from "../../Actions/LogicActions/FmlmSearch/FmlmGeoService";
import { FmlmViewOffersResponseMapType } from "../../Flows/FmlmDetail/Context/FmlmViewContext";
import { IRailPreferences } from "../Types/Index";

export const FMLM_BOOKABLE_OPTIONS: ReadonlyArray<string> = ["TRAIN", "SHUTTLE"];

export const locationMapVisibleAtom = atom<boolean>({
  key: "locationMapVisibleAtom",
  default: false,
});

export const locationDataAtom = atom<any[]>({
  key: "locationDataAtom",
  default: [],
});

export const selectedLocationAtom = atom<LocationState | null>({
  key: "selectedLocationAtom",
  default: null,
});

export const selectedLocationDestinationAtom = atom<LocationState | null>({
  key: "selectedLocationDestinationAtom",
  default: null,
});

export const fmlmSubStationDropdownAtom = atom<{ [key: string]: boolean }>({
  key: "fmlmSubStationDropdownAtom",
  default: {},
});

export const locationPermissionStateAtom = atom<LocationPermissionState>({
  key: "locationPermissionStateAtom",
  default: {
    isGranted: false,
  },
});

export const fmlmReverseGeoCodeLocationAtom = atom<ReverseGeocodeResult | null>({
  key: "fmlmReverseGeoCodeLocationAtom",
  default: null,
});

export const currentLocationAtom = atom<ReverseGeocodeResult | null>({
  key: "currentLocationAtom",
  default: null,
});

export const fmlmViewInformationAtom = atom<IFmlmView[]>({
  key: "fmlmViewInformationAtom",
  default: [],
});

export const fetchingFmlmViewInformationAtom = atom<boolean>({
  key: "fetchingFmlmViewInformationAtom",
  default: false
});

export const fmlmViewOffersMapAtom = atom<FmlmViewOffersResponseMapType>({
  key: "fmlmViewOffersMapAtom",
  default: new Map(),
});

export const selectedFmlmJourneyAtom = atom<IFmlmView | null>({
  key: "selectedFmlmJourneyAtom",
  default: null,
});

export const selectedInboundFmlmJourneyAtom = atom<IFmlmView | null>({
  key: "selectedInboundFmlmJourneyAtom",
  default: null,
});

export const isTimerVisibleAtom = atom<boolean>({
  key: "isTimerVisibleAtom",
  default: false,
});

export const isFmlmFilterTimerModelOpenAtom = atom<boolean>({
  key: "isFmlmFilterTimerModelOpenAtom",
  default: false,
});

export const isFmlmInboundTimeModalOpenAtom = atom<boolean>({
  key: "isFmlmInboundTimeModalOpenAtom",
  default: false,
});

export const fmlmFilterAtom = atom<IFmlmFilter | null>({
  key: "fmlmFilterAtom",
  default: DEFAULT_FMLM_FILTER_STATE,
});

export const isDepartureDateChangedAtom = atom<boolean>({
  key: "isDepartureDateChangedAtom",
  default: true,
});

export type IFmlmFavouriteLocationAtom = NonNullable<IRailPreferences["firstAndLastMile"]>;
export const fmlmFavouriteLocationAtom = atom<IFmlmFavouriteLocationAtom | null>({
  key: 'fmlmFavouriteLocationAtom',
  default: null
})

export const fmlmJourneyResponseAtom = atom<IFmlmJourneyResponseAtom | null>({
  key: "fmlmJourneyResponseAtom",
  default: null
});

export const allFmlmJourneyAtom = atom<IFmlmView[]>({
  key: "allFmlmJourneyAtom",
  default: []
});

// This atom is used to store the last paginated offer date for FMLM view information for pagination purposes.
export const lastFmlmFetchOfferDateAtom = atom<number | null>({
  key: "lastFmlmFetchOfferDateAtom",
  default: null
});
